import { TGpsrRegulationsItem } from 'redux/reducers/gpsr/types';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from '../../../ui/EasTable/EasTableRow/EasTableValue/constants';

// {
// 	id: number;
// 	emId: number;
// 	productTypeId: number;
// 	regulations: string;
// }

export const gpsrRegulationsTableStructure: TTableStructure<keyof TGpsrRegulationsItem>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TGpsrRegulationsItem,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'EM ID',
		selector: 'emId' as keyof TGpsrRegulationsItem,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Product Type ID',
		selector: 'productTypeId' as keyof TGpsrRegulationsItem,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Regulation Name',
		selector: 'name' as keyof TGpsrRegulationsItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 4,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TGpsrRegulationsItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		buttons: [{ name: 'Delete', icon: EIconButtons.DELETE, color: 'error.main' }],
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
];
